import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import type { ApolloError } from '@apollo/react-hooks';
import { type ApplicationRemarkType } from '../../../../Nomination/graphql';

const GET_APPLICATION_TODO_LIST = gql`
  query ($applicationId: String!, $id: ID!) {
    applicationToDoList(applicationId: $applicationId) {
      todoList
      visibleList
      applicationStatus
      isLocal
      studentNumber
    }
    application(id: $id) {
      remarks {
        fromRole
        toRole
        remark
        createdAt
      }
    }
    checkOVTSCompletion(applicationId: $applicationId)
  }
`;

export type ApplicationToDoList = {
  todoList: string[];
  visibleList: string[];
  applicationStatus: string;
  isLocal: boolean;
  studentNumber: string;
};

export type GetApplicationToDoListVariables = {
  applicationToDoList: ApplicationToDoList;
  remarks: ApplicationRemarkType[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetApplicationToDoList = (
  applicationId: string,
  skip?: boolean,
): GetApplicationToDoListVariables => {
  const { data, loading, error, refetch } = useQuery(
    GET_APPLICATION_TODO_LIST,
    {
      variables: { applicationId, id: applicationId },
      fetchPolicy: 'network-only',
      skip: !applicationId || skip === true,
    },
  );

  const { todoList, visibleList, applicationStatus, isLocal, studentNumber } =
    data?.applicationToDoList ?? {};

  const filteredToDoList = (todoList ?? []).filter((key: any) =>
    visibleList?.includes(key),
  );

  const remarks: ApplicationRemarkType[] = data?.application?.remarks ?? [];

  return {
    applicationToDoList: {
      todoList: filteredToDoList,
      visibleList: visibleList ?? [],
      applicationStatus: applicationStatus ?? '',
      isLocal: isLocal ?? false,
      studentNumber: studentNumber ?? '',
    },
    remarks,
    loading,
    error,
    refetch,
  };
};
